import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.log(error);
    Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <Box style={{ padding: 5 }}>Something went wrong.</Box>;
    }

    return this.props.children;
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.any
};
export default ErrorBoundary;
